import layout from '@/views/layout/layout.vue'
const miniProgramConfigEdit = r => require.ensure([], () => r(require('@/views/system/miniProgramConfig/edit.vue')), 'group-system-miniProgramConfig')

const systemMiniProgramConfig = [
  {
    path: '/system/miniProgramConfig',
    name: 'system-miniProgramConfig',
    component: layout,
    redirect: '/system/miniProgramConfig/edit',
    children: [
      {
        path: 'edit',
        component: miniProgramConfigEdit,
        name: 'system-miniProgramConfig-edit',
        meta: {
          displayName: '拍照相机配置',
          requireAuth: true
        }
      }
    ]
  }
]

export default systemMiniProgramConfig



// WEBPACK FOOTER //
// ./src/router/system/miniProgramConfig.js